import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'


import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, List,InputNumber,
  TimePicker,Checkbox, message} from 'antd';


import './styles.scss'

import { SendPasswordResetEmail} from "../../Redux/actions/authentication";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({navbutton}) => { 
    
    const dispatch = useDispatch()    

    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [modalWidth, setmodalWidth] = useState('80%')
    const [loading, setLoading] = useState(false)

    const [email, setEmail] = useState(null)


    useEffect(() => {
 
      
    },[]);

    const sendEmail = () =>{ 
      setLoading(true)
      dispatch(SendPasswordResetEmail(email))
      .then(res => {
        // Signed in
        message.success('Password reset email sent! check your spam mail')
        setLoading(false)
        setEmail(null)
        setIsModalVisible(false)
 
      })
      .catch(error => {
        var errorCode = error.code;
        var errorMessage = error.message;
        message.error(errorMessage)
        setLoading(false)
      });
    
    }
    
        
    const footer = () =>{
  
      return(  
    
          <Button type='primary' disabled={!emailValidation()} loading={loading} onClick={()=>{sendEmail()}} >
            Send Verification Email
          </Button>   
      )
     
    }

    
    const closeModal = (action) =>{
      if(!loading){
          setIsModalVisible(false);          
      }
    }


    const emailValidation = () =>{
      const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if(!email || regex.test(email) === false){  
          return false;
      }
      return true;
    }

 

    return(       
      <> 

      <Button type='link' onClick={()=>{setIsModalVisible(true); setLoading(false)}} >{`Forgot Password`}</Button>  
      
      {isModalVisible?  
        <Modal title={'Forgot Password'}  visible={isModalVisible} footer={footer()} onCancel={()=>{closeModal()}} >
          <div className="">
          <Input type='email' placeholder="Your email" onChange={(e)=>setEmail(e.target.value)} />
            
          </div>
        </Modal>
        :null}
      </>
    )
}
  
export default Index
  